import { useTranslation } from '@numistic/i18n'

/** Заглушки карточек на время загрузки — страница не «прыгает» и видно, что идёт загрузка. */
export function GridSkeleton({ count = 8, className }: { count?: number; className: string }) {
  const { t } = useTranslation()
  return (
    <ul className={className} aria-busy="true" aria-label={t('common.loading')}>
      {Array.from({ length: count }, (_, i) => (
        <li key={i} className="grid gap-2 rounded-lg border bg-card p-2">
          <div className="aspect-square animate-pulse rounded-md bg-muted" />
          <div className="h-4 w-3/4 animate-pulse rounded bg-muted" />
          <div className="h-3 w-1/2 animate-pulse rounded bg-muted" />
        </li>
      ))}
    </ul>
  )
}
